import request from '@/utils/request'

const statistics = {
  // // 查询成交统计数
  // getBoSuccessCount (data) {
  //   return request({
  //     url: '/scrmStatistic/selectBoSuccsesSumMb',
  //     method: 'post',
  //     data: data
  //   })
  // },
  // // 查询商机统计数
  // getBoCount (data) {
  //   return request({
  //     url: '/scrmStatistic/selectBoSumMb',
  //     method: 'post',
  //     data: data
  //   })
  // },
  // // 查询客户统计数
  // getCustCount (data) {
  //   return request({
  //     url: '/scrmStatistic/selectCustSumMb',
  //     method: 'post',
  //     data: data
  //   })
  // },
  // // 查询公海统计数
  // getSeaCount (data) {
  //   return request({
  //     url: '/scrmStatistic/selectSeaSumMb',
  //     method: 'post',
  //     data: data
  //   })
  // },
  // 查询统计数
  getCount (data) {
    return request({
      url: '/scrmStatistic/selectCountMb',
      method: 'post',
      data: data
    })
  },
  // 按部门查询成交统计数
  getBoSuccessCountByDept (data) {
    return request({
      url: '/scrmStatistic/selectBoSuccessSumByDeptSumMb',
      method: 'post',
      data: data,
      options: {
        loading: true,
        loadingText: '数据获取中'
      }
    })
  },
  // 按部门查询商机统计数
  getBoCountByDept (data) {
    return request({
      url: '/scrmStatistic/selectBoSumByDeptSumMb',
      method: 'post',
      data: data,
      options: {
        loading: true,
        loadingText: '数据获取中'
      }
    })
  },
  // 按部门查询客户统计数
  getCustCountByDept (data) {
    return request({
      url: '/scrmStatistic/selectCustSumByDeptMb',
      method: 'post',
      data: data,
      options: {
        loading: true,
        loadingText: '数据获取中'
      }
    })
  },
  // 按部门统计无商机客户数
  getNotBoCountByDept (data) {
    return request({
      url: '/scrmStatistic/selectNotBoByDeptSumMb',
      method: 'post',
      data: data,
      options: {
        loading: true,
        loadingText: '数据获取中'
      }
    })
  },
  // 商机阶段数据分析
  getFunnelData (data) {
    return request({
      url: '/scrmStatistic/selectLoudouMb',
      method: 'post',
      data: data,
      options: {
        loading: true,
        loadingText: '数据获取中'
      }
    })
  },
  // 客户等级区分
  getCustLevelData (data) {
    return request({
      url: '/scrmStatistic/selectLevelMb',
      method: 'post',
      data: data,
      options: {
        loading: true,
        loadingText: '数据获取中'
      }
    })
  },
  // 所属行业区分
  getIndustryData (data) {
    return request({
      url: '/scrmStatistic/selectIndustryMb',
      method: 'post',
      data: data,
      options: {
        loading: true,
        loadingText: '数据获取中'
      }
    })
  },
  // 客户来源区分
  getCustSourceData (data) {
    return request({
      url: '/scrmStatistic/selectCustSourceMb',
      method: 'post',
      data: data,
      options: {
        loading: true,
        loadingText: '数据获取中'
      }
    })
  },
  // 所属地区区分
  getAreaData (data) {
    return request({
      url: '/scrmStatistic/selectDistrictMb',
      method: 'post',
      data: data,
      options: {
        loading: true,
        loadingText: '数据获取中'
      }
    })
  },
  // 单位性质区分
  getUnitNatureData (data) {
    return request({
      url: '/scrmStatistic/selectUnitNatureMb',
      method: 'post',
      data: data,
      options: {
        loading: true,
        loadingText: '数据获取中'
      }
    })
  },
  // 统计合同数
  getContractCount (data) {
    return request({
      url: '/contStatistic/selectContSum',
      method: 'post',
      data: data
    })
  },
  // 按部门统计合同金额
  getContractCountByDept (data) {
    return request({
      url: '/contStatistic/selectContractMoneyByDeptMb',
      method: 'post',
      data: data,
      options: {
        loading: true,
        loadingText: '数据获取中'
      }
    })
  },
  // 按部门统计回款金额
  getPaymentCountByDept (data) {
    return request({
      url: '/contStatistic/selectPayMoneyByDeptMb',
      method: 'post',
      data: data,
      options: {
        loading: true,
        loadingText: '数据获取中'
      }
    })
  },
  // 销售业务类型业绩分析
  getSaleTypeData (data) {
    return request({
      url: '/contStatistic/selectBusinessMb',
      method: 'post',
      data: data,
      options: {
        loading: true,
        loadingText: '数据获取中'
      }
    })
  },
  // 合同所属行业分析
  getContIndustry (data) {
    return request({
      url: '/contStatistic/selectContIndustryMb',
      method: 'post',
      data: data,
      options: {
        loading: true,
        loadingText: '数据获取中'
      }
    })
  },
  // 合同客户级别分析
  getContCustLevl (data) {
    return request({
      url: '/contStatistic/selectContLevelMb',
      method: 'post',
      data: data,
      options: {
        loading: true,
        loadingText: '数据获取中'
      }
    })
  },
  // 合同所属地区分析
  getContCustArea (data) {
    return request({
      url: '/contStatistic/selectContDistrictMb',
      method: 'post',
      data: data,
      options: {
        loading: true,
        loadingText: '数据获取中'
      }
    })
  },
  // 媒体版位数据分析
  getMediaLocation (data) {
    return request({
      url: '/contStatistic/selectContMediaLocationMb',
      method: 'post',
      data: data,
      options: {
        loading: true,
        loadingText: '数据获取中'
      }
    })
  },
  // 投放链路数据分析
  getDeliveryLink (data) {
    return request({
      url: '/contStatistic/selectContDeliveryLinkMb',
      method: 'post',
      data: data,
      options: {
        loading: true,
        loadingText: '数据获取中'
      }
    })
  },
  // 获取各个事业部
  getDeptList (query) {
    return request({
      url: 'system/dept/list',
      method: 'get',
      params: query,
      options: {
        loading: true
      }
    })
  },

  // 统计收款汇总表格  事业部业绩统计
  listAllIncomeSum(query) {
    return request({
      url: '/cont/newIncomeDetail/allIncomeSumList',
      method: 'get',
      params: query,
      options: {
        loading: true
      }
    })
  },

  // 查询公司账户余额
  listAccountBalances(query) {
    return request({
      url: '/fina/accountDetail/accountBalances',
      method: 'get',
      params: query
    })
  },
  // 导出公司账户余额
  exportAccountBalances(query) {
    return request({
      responseType: 'blob',
      url: '/fina/accountDetail/excelAccountBalances',
      method: 'get',
      params: query
    })
  },

  // 业绩消耗统计  post
  getDateMoneyRatio(data) {
    return request({
      url: '/cont/accountStatistics/getDateMoneyRatio',
      method: 'post',
      data: data,
      options: {
        loading: true,
        loadingText: '数据获取中'
      }
    })
  },
  // 垫款统计
  getAdvancesStatistics(query) {
    return request({
      url: '/cont/advancesConsumeDetail/advancesStatistics',
      method: 'get',
      params: query,
      options: {
        loading: true,
        loadingText: '数据获取中'
      }
    })
  },
  // 获取部门临时授信 get
  getTemporaryBalance(query) {
    return request({
      url: '/cont/advancesConsumeDetail/temporaryBalance',
      method: 'get',
      params: query,
      options: {
        loading: true,
        loadingText: '数据获取中'
      }
    })
  },
  // 垫款趋势分析
  getAdvancesTendency(query) {
    return request({
      url: '/cont/advancesConsumeDetail/advancesTendency',
      method: 'get',
      params: query,
      options: {
        loading: true,
        loadingText: '数据获取中'
      }
    })
  },
  // 事业部垫款分析
  getAdvancesPieChart(query) {
    return request({
      // url: '/cont/advancesConsumeDetail/getPieChart',
      url: '/cont/advancesConsumeDetail/getDeptUsersPieChart',
      method: 'get',
      params: query,
      options: {
        loading: true,
        loadingText: '数据获取中'
      }
    })
  },
  // 重点客户垫款情况TOP
  getEmphasisAdvancesTop(query) {
    return request({
      url: '/cont/advancesConsumeDetail/getEmphasisAdvancesTOP',
      method: 'get',
      params: query,
      options: {
        loading: true,
        loadingText: '数据获取中'
      }
    })
  },
  // 客户垫款情况TOP
  getAdvancesTopList(query) {
    return request({
      url: '/cont/advancesConsumeDetail/getAdvancesTOP',
      method: 'get',
      params: query,
      options: {
        loading: true,
        loadingText: '数据获取中'
      }
    })
  }
}
export default statistics
